import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./youTubeProject/App";
// import App from './introToReact/App'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,

  document.getElementById("root")
);
